var HEADER = 'Montserrat, sans-serif';
var BODY = 'Inter, sans-serif';
//const BODY = 'Outfit, sans-serif'
var typography = {
    fontFamily: [
        'Montserrat',
        'Inter, sans-serif',
        'sans-serif',
    ].join(','),
    // Typography scale remains in rem to maintain proportions
    h1: {
        fontFamily: HEADER,
        fontSize: '6rem',
        fontWeight: 300,
        lineHeight: 1.167,
        letterSpacing: '-0.01562em',
    },
    h2: {
        fontFamily: HEADER,
        fontSize: '3.75rem',
        fontWeight: 300,
        lineHeight: 1.2,
        letterSpacing: '-0.00833em',
    },
    h3: {
        fontFamily: HEADER,
        fontSize: '3rem',
        fontWeight: 500,
        lineHeight: 1.167,
        letterSpacing: '0em',
    },
    h4: {
        fontFamily: HEADER,
        fontSize: '2.125rem',
        fontWeight: 500,
        lineHeight: 1.235,
        letterSpacing: '0.00735em',
    },
    h5: {
        fontFamily: HEADER,
        fontSize: '1.5rem',
        fontWeight: 500,
        lineHeight: 1.334,
        letterSpacing: '0em',
    },
    h6: {
        fontFamily: HEADER,
        fontSize: '1.25rem',
        fontWeight: 500,
        lineHeight: 1.6,
        letterSpacing: '0.0075em',
    },
    subtitle1: {
        fontFamily: BODY,
        fontSize: '1rem',
        fontWeight: 500,
        lineHeight: 1.3,
        letterSpacing: '0.00938em',
    },
    subtitle2: {
        fontFamily: BODY,
        fontSize: '0.875rem',
        fontWeight: 500,
        lineHeight: 1.57,
        letterSpacing: '0.00714em',
    },
    body1: {
        fontFamily: BODY,
        fontSize: '1rem',
        fontWeight: 400,
        lineHeight: 1.5,
        opacity: '0.95',
        letterSpacing: '0.00938em',
    },
    body2: {
        fontFamily: BODY,
        fontSize: '0.875rem',
        fontWeight: 400,
        lineHeight: 1.43,
        opacity: '0.9',
        letterSpacing: '0.01071em',
    },
    button: {
        fontFamily: BODY,
        fontSize: '0.875rem',
        fontWeight: 500,
        lineHeight: 1.75,
        letterSpacing: '0.02857em',
        textTransform: 'uppercase',
    },
    caption: {
        fontFamily: BODY,
        fontSize: '0.75rem',
        fontWeight: 400,
        lineHeight: 1.66,
        letterSpacing: '0.03333em',
    },
    overline: {
        fontFamily: BODY,
        fontSize: '0.75rem',
        fontWeight: 400,
        lineHeight: 2.66,
        letterSpacing: '0.08333em',
        textTransform: 'uppercase',
    },
};
export default typography;
